module.exports = __webpack_public_path__ + "static/media/merriweather-bold-webfont.6d33d169.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-bold-webfont.woff2
// module id = 295
// module chunks = 0